<formstep-detail ref="formstepDetail" html-id="faq" :options="options" :editable="true" :model="faq"></formstep-detail>